module.exports = __webpack_public_path__ + "img/slider-enabled.e42e718f.svg";